<template>
    <div class="intro-page">
        <!-- PC 端 集团简介图片 -->
        <div class="intro-pc" v-show="isPC">
            <img src="../../assets/intro-pc.jpg" alt="集团简介" />
        </div>

        <!-- 移动端 集团简介图片 -->
        <div class="intro-mobile" v-show="!isPC">
            <img src="../../assets/intro-mobile.jpg" alt="集团简介" />
        </div>
        <!-- <div class="page-title">
        <h2>集团简介</h2>
        <p class="en-title">COMPANY PROFILE</p>
      </div>
      <div class="content">
        <p>湖北港口集团有限公司（简称“湖北港口集团”）前身为武汉港航发展集团有限公司（简称“港发集团”）。2021年4月，省委省政府为加快全省港口资源整合的决策部署，将武汉港发集团更名为湖北省港口集团有限公司，整合省属国企及长江、汉江沿线地市的国有港口资产。2022年4月，集团再次改革重组，并更名为“湖北港口集团”。公司地址：武汉市江岸区沿江大道136号。</p>
        <p>湖北港口集团定位为市场竞争类企业，战略目标：“加快建成国内一流航运枢纽、一流港口企业、一流开放通道”战略目标。作为全省港口航运投资、建设、运营主体，以建设长江中游航运中心和多式联运国家物流枢纽为使命，致力于打造全国一流、内河最大的现代港口服务商、综合物流集成商、临港园区运营商。</p>
        <p>湖北港口集团是深度融入“一带一路”、长江经济带两大国家战略，开放程度较高的企业平台，旗下运营的中欧（武汉）班列、“武汉-日韩”江海直达航线，形成“向西入欧、向东出海”开放格局。主要运营三大主业：一是港口服务，形成“以武汉港为龙头，鄂东南、宜昌荆州港为两翼，汉江港为延展”的一体化发展格局。二是综合物流，打造专业化航运品牌，发展多式联运，高效运行中欧（武汉）班列，形成国内国际双向拓展、人物资信“四流”融合、铁水公空“四网”联运的综合物流集成体系。三是临港园区建设开发运营。</p>
      </div> -->
    </div>
</template>

<script>
export default {
    name: "TabIntro",
    data() {
        return {
            isPC: true
        };
    },
    mounted() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        onResize() {
            this.isPC = window.innerWidth >= 992;
        }
    }
};
</script>

<style scoped lang="less">
.intro-page {
    width: 100%;

    img {
        width: 100%;
        height: auto;
        display: block;
    }

    // .page-title {
    //   text-align: center;
    //   margin-bottom: 24px;
    //   position: relative;
    //   &::before {
    //     content: 'COMPANY PROFILE';
    //     position: absolute;
    //     top: 50%;
    //     left: 50%;
    //     transform: translate(-50%, -50%);
    //     font-size: 36px;
    //     color: #eee;
    //     z-index: 0;
    //   }
    //   h2 {
    //     position: relative;
    //     font-size: clamp(20px, 4vw, 28px);
    //     color: #0056b3;
    //     z-index: 1;
    //     &::after {
    //       content: '';
    //       display: block;
    //       width: 60px;
    //       height: 4px;
    //       background: #ffc107;
    //       margin: 8px auto 0;
    //     }
    //   }
    //   .en-title {
    //     font-size: 14px;
    //     color: #999;
    //   }
    // }
    // .content {
    //   line-height: 1.8;
    //   font-size: clamp(14px, 3vw, 16px);
    //   color: #333;
    //   p {
    //     margin-bottom: 16px;
    //     text-indent: 2em;
    //   }
    // }
}
</style>